import { fetchWithAuth } from '../lib/fetchWithAuth';

const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type ApplicationStatus = 'interview' | 'shortlisted' | 'reviewed' | 'pending' | 'rejected';

export type CandidateApplication = {
  id: string | number;
  jobId: string | number;
  jobSlug?: string;
  job?: { slug?: string };
  jobTitle: string;
  company: string;
  location: string;
  salary?: string;
  type?: string;
  statusType: ApplicationStatus;
  statusLabel: string;
  appliedDate: string;
  interviewDate?: string;
  interviewTime?: string;
  nextStep?: string;
  notes?: string;
};

export async function fetchApplications(): Promise<CandidateApplication[]> {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to fetch applications.');
  }

  const response = await fetchWithAuth(`${API_BASE_URL}/v1/applications`);
  if (!response.ok) {
    throw new Error(`Applications fetch failed (${response.status})`);
  }
  const payload = await response.json();
  if (Array.isArray(payload?.data)) {
    return payload.data as CandidateApplication[];
  }
  if (Array.isArray(payload)) {
    return payload as CandidateApplication[];
  }
  throw new Error('Applications response malformed.');
}

export async function withdrawApplication(applicationId: string | number): Promise<{ success: boolean }> {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to withdraw an application.');
  }

  const response = await fetchWithAuth(`${API_BASE_URL}/v1/applications/${applicationId}/withdraw`, {
    method: 'POST',
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Withdraw failed (${response.status}): ${errorText}`);
  }

  return { success: true };
}
